import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Divider,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
} from "../../../Redux/actions/crudActions";
import { errorParser } from "../../../utils/helpers";

import CreateForm from "../../Generic/CreateForm";
import DisplayForm from "../../Generic/DisplayForm";

import ProductPriceChange from "../ProductPriceChange";
import ProductInventoryTable from "../ProductInventoryTable";
import ProductIngredientsTable from "../ProductIngredientsTable";
import ProductPictureChange from "../ProductPictureChange";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({
  currentItem,
  onModalClose,
  blueprint,
  internationalblueprint,
  modalMode,
  headername,
  token,
  apiurl,
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector(
    (state) => ({
      user: state.auth.user,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentOrder, setCurrentOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(false);
  const [modalCurrentMode, setModalCurrentMode] = useState("add");
  const [formSubmitClick, setFormSubmitClick] = useState(false);
  const [modalWidth, setmodalWidth] = useState("80%");
  const [somethingChanged, setSomethingChanged] = useState(false);
  const [refreshInventory, setRefreshInventory] = useState(false);
  const [heyPricechanged, setHeyPricechanged] = useState(null);

  const PriceBlueprint = [
    {
      title: "Peso",
      key: "cost_peso",
      type: "number",
    },
    {
      title: "RMB",
      key: "cost_rmb",
      type: "number",
    },
  ];

  useEffect(() => {
    setModalCurrentMode(modalMode);
  }, [modalMode]);

  useEffect(() => {
    if (blueprint) {
      blueprint.map((blue) => {
        if (blue.type == "email-editor" || blue.type == "site-editor") {
          setmodalWidth("94%");
        }
      });
    }

    if (currentItem && modalMode == "edit") {
      // console.log(currentItem)
      if (currentItem.id !== undefined) {
        setIsModalVisible(true);
        setItem(currentItem);
      }
    }
  }, [currentItem]);

  const saveChanges = (form) => {
    // console.log('form data',form)
    setLoading(true);
    if (form.errorFields) {
      form.errorFields.map((er) => {
        er.errors.map((err) => {
          message.error(err);
        });
      });
      setLoading(false);
    } else if (modalCurrentMode == "edit" && !item.id) {
      message.error("can't find identifier");
      setLoading(false);
    } else {
      // console.log('3')
      // console.log('form',form)
      var formData = {
        ...form,
      };
      Object.keys(formData).forEach((key) =>
        formData[key] === undefined ? delete formData[key] : {}
      );

      var form_data = {};

      Object.entries(formData).map(([key, value]) => {
        // console.log(key,value, Array.isArray(value))
        var newval = value;

        if (Array.isArray(value)) {
          if (newval.length == 0) {
            newval = [];
            // console.log(newval)
          }
        }
        form_data[key] = newval;
      });

      if (form_data.hq_only == undefined) {
        form_data["hq_only"] = false;
      }
      if (form_data.menu_item == undefined) {
        form_data["menu_item"] = false;
      }
      if (form_data.need_scan == undefined) {
        form_data["need_scan"] = false;
      }
      // console.log('formData',form_data)
      if (modalCurrentMode == "add") {
        var created_at = moment().format("YYYY-MM-DD HH:mm:ss");
        form_data["created_at"] = created_at;
        dispatch(addItem(form_data, apiurl))
          .then((res) => {
            message.success("Item Created");
            closeModal("reset");
            setLoading(false);
          })
          .catch((err) => {
            var formattedErr = errorParser(err.response);
            if (
              typeof formattedErr == "object" ||
              typeof formattedErr == "array"
            ) {
              formattedErr.map((er) => {
                message.error(er);
              });
            } else {
              message.error(formattedErr);
            }
            setLoading(false);
          });
      } else {
        var newform = {
          ...currentItem,
          ...form_data,
        };
        dispatch(editItem(newform, apiurl, item.id))
          .then((res) => {
            message.success("changes saved!");
            closeModal("reset");
            setLoading(false);
          })
          .catch((err) => {
            var formattedErr = errorParser(err.response);
            if (
              typeof formattedErr == "object" ||
              typeof formattedErr == "array"
            ) {
              formattedErr.map((er) => {
                message.error(er);
              });
            } else {
              message.error(formattedErr);
            }
            setLoading(false);
          });
      }
    }
  };

  const deleteCurrent = () => {
    setLoading(true);
    if (!item.id) {
      message.error("can't find identifier");
      setLoading(false);
    } else {
      dispatch(deleteItem(apiurl, item.id))
        .then((res) => {
          message.success("item deleted!");
          closeModal("reset");
          setLoading(false);
        })
        .catch((err) => {
          var formattedErr = errorParser(err.response);
          if (
            typeof formattedErr == "object" ||
            typeof formattedErr == "array"
          ) {
            formattedErr.map((er) => {
              message.error(er);
            });
          } else {
            message.error(formattedErr);
          }
          setLoading(false);
        });
    }
  };

  const disabledDate = (current) => {
    return current < moment().endOf("day");
  };

  const footer = () => {
    return (
      <div>
        {modalCurrentMode == "edit" &&
        user &&
        (user.role == "admin" ||
          user.role == "warehouse" ||
          user.role == "manager") ? (
          <Popconfirm
            title="Are you sure to delete this?"
            onConfirm={() => {
              deleteCurrent();
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" loading={loading}>
              Delete
            </Button>
          </Popconfirm>
        ) : null}

        {user &&
        (user.role == "admin" ||
          user.role == "warehouse" ||
          user.role == "manager") &&
        modalCurrentMode == "add" ? (
          <Button
            type="primary"
            loading={loading}
            onClick={() => {
              setFormSubmitClick(true);
            }}
          >
            {modalCurrentMode == "add" ? "Create" : "Save Changes"}
          </Button>
        ) : null}
      </div>
    );
  };

  const closeModal = (action) => {
    if (!loading) {
      if (modalCurrentMode == "edit") {
        setItem(null);
      }
      setIsModalVisible(false);
      setHeyPricechanged(null);

      if (somethingChanged) {
        onModalClose("reset");
      } else {
        onModalClose(action);
      }
    }
  };
  const renderForms = () => {
    if (user.role == "admin") {
      return (
        <CreateForm
          currentItem={item}
          blueprint={blueprint}
          token={token}
          saveForm={(e) => {
            saveChanges(e);
            setFormSubmitClick(false);
          }}
          FormSubmitClick={formSubmitClick}
        />
      );
    } else if (user.role == "warehouse" || user.role == "manager") {
      if (modalCurrentMode == "add") {
        return (
          <CreateForm
            currentItem={item}
            blueprint={blueprint}
            token={token}
            saveForm={(e) => {
              saveChanges(e);
              setFormSubmitClick(false);
            }}
            FormSubmitClick={formSubmitClick}
          />
        );
      } else {
        if (modalCurrentMode == "edit" && currentItem) {
          if (currentItem.regionalization == "local") {
            return (
              <CreateForm
                currentItem={item}
                blueprint={blueprint}
                token={token}
                saveForm={(e) => {
                  saveChanges(e);
                  setFormSubmitClick(false);
                }}
                FormSubmitClick={formSubmitClick}
              />
            );
          } else {
            return (
              <DisplayForm
                currentItem={item}
                blueprint={internationalblueprint}
                token={token}
                saveForm={(e) => {
                  saveChanges(e);
                  setFormSubmitClick(false);
                }}
                FormSubmitClick={formSubmitClick}
              />
            );
          }
        } else {
          return (
            <DisplayForm
              currentItem={item}
              blueprint={internationalblueprint}
              token={token}
              saveForm={(e) => {
                saveChanges(e);
                setFormSubmitClick(false);
              }}
              FormSubmitClick={formSubmitClick}
            />
          );
        }
      }
    } else {
      return (
        <DisplayForm
          currentItem={item}
          blueprint={internationalblueprint}
          token={token}
          saveForm={(e) => {
            saveChanges(e);
            setFormSubmitClick(false);
          }}
          FormSubmitClick={formSubmitClick}
        />
      );
    }
  };

  return (
    <>
      {user &&
      (user.role == "admin" ||
        user.role == "warehouse" ||
        user.role == "manager") ? (
        <div className={"addeditbutton"}>
          <Button
            type="primary"
            shape="round"
            icon={<PlusOutlined />}
            onClick={() => {
              setModalCurrentMode("add");
              setIsModalVisible(true);
              setLoading(false);
            }}
          >{`Add ${headername}`}</Button>
        </div>
      ) : null}

      {isModalVisible ? (
        <Modal
          title={
            modalCurrentMode == "add"
              ? `Add ${headername}`
              : `Edit ${headername}`
          }
          visible={isModalVisible}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
          width={"720px"}
        >
          <div className="productaddedit-content">
            {user &&
            currentItem &&
            (user.role == "admin" ||
              user.role == "manager" ||
              user.role == "warehouse") &&
            modalCurrentMode == "edit" ? (
              <ProductPictureChange
                currentItem={currentItem}
                somethingChanged={() => {
                  setSomethingChanged(true);
                }}
              />
            ) : null}
            {user ? renderForms() : null}
            {user &&
            (user.role == "admin" ||
              user.role == "warehouse" ||
              user.role == "manager") &&
            modalCurrentMode == "edit" ? (
              <Button
                type="primary"
                loading={loading}
                onClick={() => {
                  setFormSubmitClick(true);
                }}
              >
                {modalCurrentMode == "add" ? "Create" : "Save Changes"}
              </Button>
            ) : null}
            {user &&
            modalCurrentMode == "edit" &&
            (user.role == "admin" ||
              (user.role == "warehouse" &&
                !currentItem.menu_item &&
                currentItem.regionalization == "local")) ? (
              <div>
                <Divider orientation="left">Price</Divider>
                <ProductPriceChange
                  currentItem={currentItem}
                  somethingChanged={() => {
                    setSomethingChanged(true);
                  }}
                  heyPricechanged={heyPricechanged}
                />
              </div>
            ) : null}
            {user &&
            user.role &&
            modalCurrentMode == "edit" &&
            currentItem &&
            !currentItem.menu_item ? (
              <div>
                <Divider orientation="left">Inventory</Divider>
                <ProductInventoryTable
                  currentItem={currentItem}
                  refresh={refreshInventory}
                  somethingChanged={() => {
                    setSomethingChanged(true);
                    closeModal("reset");
                  }}
                />
                {user &&
                (user.role == "admin" || user.role == "manager") &&
                currentItem ? (
                  <div className={"incoming"}>
                    Incoming count: {currentItem.incoming_count}{" "}
                  </div>
                ) : null}
              </div>
            ) : null}
            {user &&
            (user.role == "admin" ||
              user.role == "warehouse" ||
              user.role == "manager" ||
              (user.branch == "EbJPvhCb11UaKbutec49" && user.role == "oic")) &&
            modalCurrentMode == "edit" ? (
              <div>
                <Divider orientation="left">Ingredients</Divider>
                <ProductIngredientsTable
                  currentItem={currentItem}
                  somethingChanged={() => {
                    setSomethingChanged(true);
                  }}
                  heyPricechanged={(e) => {
                    setHeyPricechanged(e);
                  }}
                />
              </div>
            ) : null}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
